<template>
  <v-autocomplete
    :value="value"
    @input="(v) => $emit('input', v)"
    :search-input.sync="typeSearchKey"
    :items="data"
    :loading="loading"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot"></slot>
    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
    >
      <slot :name="slot" v-bind="scope"></slot>
    </template>
  </v-autocomplete>
</template>

<script>
import axios from "axios";
let cancelToken;
export default {
  props: {
    value: undefined,
    api: String,
    defaultItems: Array,
    mapValue: String,
    sortItem: Function,
    emitOnSearch: Boolean
  },
  inheritAttrs: false,
  data: () => ({
    initialLoad: false,
    typeSearchKey: "",
    data: [],
    loading: false
  }),
  methods: {
    loadData(searchTerm = "", isInitialLoad = false) {
      if (!this.api) {
        return;
      }
      if (!isInitialLoad && !this.initialLoad) {
        return;
      }
      searchTerm === null && (searchTerm = "");
      this.loading = true;
      let query = this.api.includes("?") ? `&limit=${limit}` : `?limit=40`;
      if (searchTerm !== "") {
        query += `&searchTerm=${encodeURIComponent(searchTerm)}`;
      }
      if (cancelToken) {
        cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      cancelToken = axios.CancelToken.source();
      axios
        .get(`${process.env.VUE_APP_API}${this.api}${query}`, {
          cancelToken: cancelToken.token
        })
        .then((result) => {
          let data;
          if (Array.isArray(result.data)) {
            data = result.data;
          } else {
            data = result.data.data;
          }
          if (this.mapValue) {
            data = data.map((item) => item[this.mapValue]);
          }
          if (this.defaultItems) {
            data = [...this.defaultItems, ...data];
          }
          if (this.sortItem) {
            data = data.sort(this.sortItem);
          }
          this.data = data;
        })
        .finally(() => {
          setTimeout(() => {
            this.initialLoad = true;
          }, 100);
          this.loading = false;
        });
    }
  },
  mounted() {
    if (this.value?.length) {
      if (this.mapValue) {
        this.data = [this.value];
      }
      this.loadData(this.value, true);
    } else {
      this.loadData("", true);
    }
  },
  watch: {
    typeSearchKey: function(text) {
      if (this.emitOnSearch && this.$attrs["item-text"]) {
        const emitValue = {};
        emitValue[this.$attrs["item-text"]] = text;
        this.$emit("input", emitValue);
      }
      this.loadData(text);
    }
  }
};
</script>
